import styled from 'styled-components';

export const IconContainer = styled.div`
    display: flex;
    height: 2rem;
    width: 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    background-color: rgb(95, 83, 220);
    flex-shrink: 0;

    svg {
        height: 1rem;
        width: 1rem;
        color: white;
        flex-shrink: 0;
    }
`;

export const DropdownIconContainer = styled.div`
    display: flex;
    height: 2rem;
    width: 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    background-color: white;
    border: 2px solid rgb(95, 83, 220);
    flex-shrink: 0;

    svg {
        height: 1rem;
        width: 1rem;
        color: rgb(95, 83, 220);
        flex-shrink: 0;
    }
`;

export const OrganizationInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    flex: 1;
    overflow: hidden;
`;

export const OrganizationName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    font-weight: 700;
    color: hsl(var(--sidebar-foreground));
`;

export const OrganizationLabel = styled.span`
    font-size: 0.75rem;
    color: hsl(var(--sidebar-foreground) / 0.7);
`;

export const DropdownOrganizationName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    font-weight: 500;
`;

export const DropdownOrganizationLabel = styled.span`
    font-size: 0.75rem;
    color: hsl(var(--muted-foreground));
`;
